import { each, values } from 'lodash';
import callApi from '../../util/apiCaller';
import { resetTVCollectorMappings, resetTVProductMappings } from '../Setup/SetupActions';
import { resetTVPrograms } from '../Nomination/NominationActions';

// Export Constants
export const ADD_ALL_ORGANIZATIONS = 'ADD_ALL_ORGANIZATIONS';
export const VIEW_ORGANIZATION = 'VIEW_ORGANIZATION';
export const DELETE_ORGANIZATION = 'DELETE_ORGANIZATION';
export const ADD_ORGANIZATION = 'ADD_ORGANIZATION';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const ADD_ALL_PI_USERS = 'ADD_ALL_PI_USERS';
export const ADD_ALL_ADMIN_USERS = 'ADD_ALL_ADMIN_USERS';
export const VIEW_PI_USER = 'VIEW_PI_USER';
export const VIEW_PI_USER_ORGANIZATIONS = 'VIEW_PI_USER_ORGANIZATIONS';
export const UNASSIGN_PI_USER_ORGANIZATION = 'UNASSIGN_PI_USER_ORGANIZATION';
export const ASSIGN_PI_USER_ORGANIZATION = 'ASSIGN_PI_USER_ORGANIZATION';
export const ADD_TRUVOICE_CLIENTS = 'ADD_TRUVOICE_CLIENTS';
export const ADD_ADMIN_NEWS = 'ADD_ADMIN_NEWS';
export const DELETE_ADMIN_NEWS = 'DELETE_ADMIN_NEWS';
export const LOAD_ADMIN_NEWS = 'LOAD_ADMIN_NEWS';
export const EDIT_ADMIN_NEWS = 'EDIT_ADMIN_NEWS';
export const ADD_DOMAIN_AUTHORIZATIONS = 'ADD_DOMAIN_AUTHORIZATIONS';
export const FETCH_TRUSALES_STATS = 'FETCH_TRUSALES_STATS';

// Export Actions

export function addAllOrganizations(organizations) {
  return {
    type: ADD_ALL_ORGANIZATIONS,
    organizations,
  };
}

export function fetchAllOrganizations(params = {}) {
  const newParams = { ...params };
  delete newParams.stats; // defer load
  
  return (dispatch) => {
    const p = callApi('organizations', 'GET', newParams);
    p.then((res) => {
      each(res.organizations.items, (item) => {
        item.$loadingStats = true;
      });
      return dispatch(addAllOrganizations(res.organizations));
    });
    if (params.stats) {
      const p2 = callApi('organizations', 'GET', params);
      p2.then((r) => {
        dispatch(addAllOrganizations(r.organizations));
      });
    }
    return p;
  }
}

export function addOrganization(organization) {
  return {
    type: ADD_ORGANIZATION,
    organization,
  };
}

export function requestAddOrganization(params) {
  return (dispatch) =>
    callApi('organizations', 'POST', params).then((res) =>
      dispatch(addOrganization(res.organization)),
    );
}

export function deleteOrganization(id) {
  return {
    type: DELETE_ORGANIZATION,
    id,
  };
}

export function requestDeleteOrganization(id) {
  return (dispatch) =>
    callApi(`organizations/${id}`, 'DELETE').then(() =>
      dispatch(deleteOrganization(id)),
    );
}

export function updateOrganization(organization) {
  return {
    type: UPDATE_ORGANIZATION,
    organization,
  };
}

export function requestUpdateOrganization(id, params = {}) {
  return (dispatch) => {
    const p = callApi(`organizations/${id}`, 'PUT', params);
    p.then((res) => {
      resetTVProductMappings()(dispatch);
      resetTVCollectorMappings()(dispatch);
      resetTVPrograms()(dispatch);
      return dispatch(updateOrganization(res.organization));
    });
    return p;
  };
}

export function viewOrganization(organization) {
  return {
    type: VIEW_ORGANIZATION,
    organization,
  };
}
export function fetchOrganization(id) {
  return (dispatch) =>
    callApi(`organizations/${id}`, 'GET').then((res) =>
      dispatch(viewOrganization(res.organization)),
    );
}

export function addAllPIUsers(users) {
  return {
    type: ADD_ALL_PI_USERS,
    users,
  };
}
export function fetchAllPIUsers(params = {}) {
  return (dispatch) =>
    callApi('pi-users', 'GET', params).then((res) =>
      dispatch(addAllPIUsers(res.users)),
    );
}

export function fetchAllAdminUsers(params = {}) {
  return (dispatch) =>
    callApi('admin-users', 'GET', params).then((res) =>
      dispatch({
        type: ADD_ALL_ADMIN_USERS,
        users: res.users,
      }),
    );
}

export function viewPIUser(user) {
  return {
    type: VIEW_PI_USER,
    user,
  };
}
export function fetchPIUser(id) {
  return (dispatch) =>
    callApi(`pi-users/${id}`, 'GET').then((res) =>
      dispatch(viewPIUser(res.user)),
    );
}

export function viewPIUserOrganizations(organizations) {
  return {
    type: VIEW_PI_USER_ORGANIZATIONS,
    organizations,
  };
}
export function fetchPIUserOrganizations(id, params = {}) {
  return (dispatch) =>
    callApi(`pi-users/${id}/organizations`, 'GET', params).then((res) =>
      dispatch(viewPIUserOrganizations(res.organizations)),
    );
}

export function unassignPIUserOrganizations(organizationId) {
  return {
    type: UNASSIGN_PI_USER_ORGANIZATION,
    organizationId,
  };
}
export function requestUnassignPIUserOrganizations(id, orgId) {
  return (dispatch) =>
    callApi(`pi-users/${id}/organizations/${orgId}`, 'DELETE').then(() =>
      dispatch(unassignPIUserOrganizations(orgId)),
    );
}

export function searchUnassignPIUserOrganizations(id, params = {}) {
  return () =>
    callApi(`pi-users/${id}/unassigned-organizations`, 'GET', params);
}

export function assignPIUserOrganization(organization) {
  return {
    type: ASSIGN_PI_USER_ORGANIZATION,
    organization,
  };
}
export function requestAssignPIUserOrganization(id, params = {}) {
  return (dispatch) =>
    callApi(`pi-users/${id}/organizations/`, 'POST', params).then((res) =>
      dispatch(assignPIUserOrganization(res.organization)),
    );
}

export function addTruVoiceClients(clients) {
  return {
    type: ADD_TRUVOICE_CLIENTS,
    clients,
  };
}
export function fetchTruVoiceClients(params = {}) {
  return (dispatch) => {
    dispatch({
      type: ADD_TRUVOICE_CLIENTS,
      clients: [],
      status: 'loading',
      errors: null,
    });
    const p = callApi('truvoice/clients', 'GET', params);
    p.then(
      (res) =>
        dispatch({
          type: ADD_TRUVOICE_CLIENTS,
          clients: res.clients,
          status: 'loaded',
          errors: null,
        }),
      (errors) =>
        dispatch({
          type: ADD_TRUVOICE_CLIENTS,
          clients: [],
          status: 'error',
          errors,
        }),
    );
    return p;
  };
}

export function fetchNews(params = {}) {
  return (dispatch) => {
    dispatch({
      type: ADD_ADMIN_NEWS,
      news: [],
      status: 'loading',
      errors: null,
    });
    return callApi('news', 'GET', params).then(
      (res) =>
        dispatch({
          type: ADD_ADMIN_NEWS,
          news: res.news,
          status: 'loaded',
          errors: null,
        }),
      (errors) =>
        dispatch({
          type: ADD_ADMIN_NEWS,
          news: [],
          status: 'error',
          errors,
        }),
    );
  };
}

export function fetchReports() {
  return () => callApi('reports', 'GET');
}

export function deleteReports(id) {
  return () => callApi(`reports/${id}`, 'DELETE');
}

export function generateReport() {
  return () => callApi('reports', 'POST');
}


export function requestUsersByRole(organization, role, params) {
  return () =>
    callApi(`organizations/${organization}/users/${role}`, 'GET', params);
}

export function requestDeleteNews(id) {
  return (dispatch) =>
    callApi(`news/${id}`, 'DELETE').then((res) =>
      dispatch({
        type: DELETE_ADMIN_NEWS,
        id,
      }),
    );
}
export function loadSingleNews(id) {
  return (dispatch) =>
    callApi(`news/${id}`, 'GET').then((res) =>
      dispatch({
        type: LOAD_ADMIN_NEWS,
        news: res.news,
      }),
    );
}
export function requestAddNews(data) {
  return (dispatch) =>
    callApi('news', 'POST', data).then((res) =>
      dispatch({
        type: EDIT_ADMIN_NEWS,
        news: res.news,
      }),
    );
}
export function requestUpdateNews(id, data) {
  return (dispatch) =>
    callApi(`news/${id}`, 'PUT', data).then((res) =>
      dispatch({
        type: EDIT_ADMIN_NEWS,
        news: res.news,
      }),
    );
}
export function resetUpdateNews() {
  return (dispatch) =>
    dispatch({
      type: EDIT_ADMIN_NEWS,
      news: null,
    });
}

export function requestUploadFile(data) {
  return (dispatch) => callApi('upload', 'POST', data, true, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  });
}

export function requestSyncTruVoice() {
  return (dispatch) => {
    dispatch({
      type: ADD_TRUVOICE_CLIENTS,
      clients: [],
      status: 'loading',
      errors: null,
    });
    return callApi('truvoice/sync', 'GET').then(
      () => dispatch(fetchTruVoiceClients()),
      (errors) =>
        dispatch({
          type: ADD_TRUVOICE_CLIENTS,
          clients: [],
          status: 'error',
          errors,
        }),
    );
  };
}

export function fetchDomainAuthorizations(id) {
  return (dispatch) => {
    dispatch({
      type: ADD_DOMAIN_AUTHORIZATIONS,
      clients: [],
      status: 'loading',
      errors: null,
      id,
    });
    const p = callApi(`organizations/${id}/truvoice-domain-authorizations`, 'GET');
    p.then(
      (results) => {
        dispatch({
          type: ADD_DOMAIN_AUTHORIZATIONS,
          clients: values(results.clients || {}),
          status: 'loaded',
          errors: null,
          id,
        });
      },
      (errors) =>
        dispatch({
          type: ADD_DOMAIN_AUTHORIZATIONS,
          clients: [],
          status: 'error',
          errors: errors?.data?.message || errors?.message || errors?.data,
          id,
        }),
    );
    return p;
  };
}

export function requestCreateDemoOrganization(id, params) {
  return (dispatch) =>
    callApi(`organizations/${id}/demo`, 'POST', params).then((res) =>
      dispatch(addOrganization(res.organization)),
    );
}

export function fetchSyncLogs(id) {
  return () => callApi(`organizations/${id}/sync-logs`, 'GET');
}

export function fetchAppUser(id) {
  return () => callApi(`organizations/${id}/app-user`, 'GET');
}

export function updateAppUser(id, params) {
  return () => {
    const p = callApi(`organizations/${id}/app-user`, 'PUT', params);
    return p;
  };
}

export function fetchSAMLSettings(id) {
  return () => callApi(`organizations/${id}/saml`, 'GET');
}

export function updateSAMLSettings(id, params) {
  return () => {
    const p = callApi(`organizations/${id}/saml`, 'PUT', params);
    return p;
  };
}

export function fetchTruSalesStats() {
  return (dispatch) => callApi(`trusales-stats`, 'GET').then(
    (res) => dispatch({
      type: FETCH_TRUSALES_STATS,
      tsStats: res,
    })
  );
}


export function fetchEmergencySettings() {
  return () => {
    const p = callApi('systems/emergency-settings', 'GET');
    return p;
  };
}

export function updateEmergencySettings(disabled) {
  return () => {
    const p = callApi('systems/emergency-settings', 'PUT', { disabled });
    return p;
  };
}

export function getMetaErrorNotificationSettings(orgId) {
  return () => {
    const p = callApi(`organizations/${orgId}/meta-error-settings`, 'GET');
    return p;
  };
}

export function updateMetaErrorNotificationSettings(orgId, params) {
  return () => {
    const p = callApi(`organizations/${orgId}/meta-error-settings`, 'PUT', params);
    return p;
  };
}